export const MINIMUM_TILE_WIDTH = 44;
export const MINIMUM_TILE_HEIGHT = 44;

export const ACCELERATION_COEFFECIENT = 1.05;
export const MAX_ACCELERATOR_DURATION = 3000;
export const MINIMUM_TIMER_INCREMENT = 10;

export const MIXED_LITTER_COOKIE_KEY = "mixed_litter_unlocked";



// WEBPACK FOOTER //
// ./src/constants.js